// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1670_","index":"styles_index__1d30m"};